import { Container } from '../../../odie';

import { ThickIceBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';
import { FullIceBlockView } from './FullIceBlockView';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'ice/block.ice.thick.png',
};

/*
    thick ice block view
*/
export class ThickIceBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: ThickIceBlockProps) {
    // create base view
    super();

    const ice = new FitWidthBlockSprite(manifest.image, props);

    this.addChild(ice);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image, ...FullIceBlockView.assets()];
  }
}
